import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DesktopLayerComponent } from './desktop/desktop-layer/desktop-layer.component';
import { GlobalComponentsModule } from '../global-components/global-components.module';
import { WindowsLayerComponent } from './desktop/windows-layer/windows-layer.component';
import { WindowComponent } from './desktop/window/window.component';
import { IframeContentComponent } from './desktop/window-contents/iframe-content/iframe-content.component';
import { ContextMenuComponent } from './ux/context-menu/context-menu.component';
import { LauncherComponent } from './desktop/launcher/launcher.component';
import { MainToolBarComponent } from './desktop/main-tool-bar/main-tool-bar.component';
import { WallpaperComponent } from './desktop/wallpaper/wallpaper.component';
import { WindowInBarComponent } from './desktop/window-in-bar/window-in-bar.component';
import { DynamicComponentContainerDirective } from './directives/dynamic-component-container.directive';
import { ResizableDraggableComponent } from './ux/resizable-draggable/resizable-draggable.component';
import { ModalsLayerComponent } from './desktop/modals-layer/modals-layer.component';
import { StartMenuComponent } from './desktop/start-menu/start-menu.component';
import { StartMenuLayerComponent } from './desktop/start-menu-layer/start-menu-layer.component';

@NgModule({
  declarations: [
    DesktopLayerComponent,
    WindowsLayerComponent,
    WindowComponent,
    IframeContentComponent,
    ContextMenuComponent,
    MainToolBarComponent,
    WallpaperComponent,
    LauncherComponent,
    ResizableDraggableComponent,
    DynamicComponentContainerDirective,
    WindowInBarComponent,
    ModalsLayerComponent,
    StartMenuComponent,
    StartMenuLayerComponent
  ],
  imports: [
    CommonModule,
    GlobalComponentsModule
  ],
  exports: [
    DesktopLayerComponent,
    WindowsLayerComponent,
    WindowComponent,
    IframeContentComponent,
    ContextMenuComponent,
    MainToolBarComponent,
    WallpaperComponent,
    LauncherComponent,
    ResizableDraggableComponent,
    DynamicComponentContainerDirective,
    WindowInBarComponent,
    ModalsLayerComponent,
    StartMenuLayerComponent
  ],
})
export class ComponentsModule {
}
